module.exports = __webpack_public_path__ + "img/Y5.92d346dc.png";